import {
  SAVE_PHOTO, SET_IS_CAMERA_ENABLED,
  SET_CAPTURED_IMAGE,
  SET_IS_PHOTO_CAPTURE_OPEN, SET_IS_SHOW_PHOTO_OPEN,
  SET_PHOTO_CAPTURE_WIZARD_STEP,
  SET_WHOS_IN_THE_PHOTO,
  START_PHOTOSHOOT,
} from './consts'


export const startPhotoshoot = () => ({
  type: START_PHOTOSHOOT,
})

export const setIsPhotoCaptureOpen = (isOpen) => ({
  type: SET_IS_PHOTO_CAPTURE_OPEN,
  isOpen,
})

export const setCapturedImage = (image) => ({
  type: SET_CAPTURED_IMAGE,
  image,
})

export const setPhotoCaptureWizardStep = (step) => ({
  type: SET_PHOTO_CAPTURE_WIZARD_STEP,
  step,
})

export const setWhoIsInThePhoto = (text) => ({
  type: SET_WHOS_IN_THE_PHOTO,
  text,
})

export const savePhoto = (capturedImage, whoIsInThePhoto) => ({
  type: SAVE_PHOTO,
  capturedImage,
  whoIsInThePhoto,
})

export const setIsShowPhotoOpen = (isOpen, url) => ({
  type: SET_IS_SHOW_PHOTO_OPEN,
  isOpen,
  url
})

export const setCameraEnabled = (enabled) => ({
  type: SET_IS_CAMERA_ENABLED,
  payload: { enabled },
})
